module.exports = __webpack_public_path__ + "media/winter_2023_sweepstakes/tiktok-social-icon-ccd56526.svg";